import ShareQuoteDialog from './ShareQuoteDialog'
export default ShareQuoteDialog
